import ActionBarItem from '@rio-cloud/rio-uikit/ActionBarItem';
import ReleaseNotesDialog from '@rio-cloud/rio-uikit/ReleaseNotesDialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { config } from '../config';

export const CUSTOMER_CENTER_RELEASE_NOTES_VERSION = config.serviceVersion;
export const CUSTOMER_CENTER_RELEASE_NOTES_STORAGE_KEY = 'customer-center-release-notes-version';
export const FEEDBACK_URL = 'https://contact-form.rio.cloud/contact?reason=feedback';

export const InformationActionBarItem = () => {
    const [showReleaseNotes, setShowReleaseNotes] = useState(false);
    const intl = useIntl();
    const moduleName = intl.formatMessage({ id: 'marketplace.customerCenter' });
    const whatsNewTitle = intl.formatMessage({ id: 'marketplace.customerCenter.info.whatsNew' });
    const releaseDate = intl.formatDate(Date.UTC(2026, 8, 1), {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
    const popoverTitle = (
        <div>
            <span>{moduleName}</span>
            <span className='text-color-gray margin-left-10'>{CUSTOMER_CENTER_RELEASE_NOTES_VERSION}</span>
        </div>
    );

    return (
        <>
            <ActionBarItem id='customer-center-information' popoverWidth={300}>
                <ActionBarItem.Icon title={moduleName}>
                    <span className='icon uikit-icon icon-info-sign' />
                </ActionBarItem.Icon>
                <ActionBarItem.Popover title={popoverTitle}>
                    <ActionBarItem.List>
                        <ActionBarItem.ListItem iconName='document' onClick={() => setShowReleaseNotes(true)}>
                            {whatsNewTitle}
                        </ActionBarItem.ListItem>
                        <ActionBarItem.ListItem iconName='send' hasLink>
                            <a href={FEEDBACK_URL} target='_blank' rel='noreferrer'>
                                <FormattedMessage id='marketplace.customerCenter.info.feedback' />
                            </a>
                        </ActionBarItem.ListItem>
                    </ActionBarItem.List>
                </ActionBarItem.Popover>
            </ActionBarItem>
            <ReleaseNotesDialog
                showReleaseNotes={showReleaseNotes}
                setShowReleaseNotes={setShowReleaseNotes}
                moduleName={moduleName}
                whatsNewTitle={whatsNewTitle}
                closeButtonText={intl.formatMessage({ id: 'marketplace.customerCenter.info.close' })}
                translatedReleaseNotes={{
                    [CUSTOMER_CENTER_RELEASE_NOTES_VERSION]: {
                        date: releaseDate,
                        content: [
                            <FormattedMessage key='minimum-term' id='intl-msg:slider.oneMonthBooking.content' />,
                            <FormattedMessage
                                key='automatic-renewal'
                                id='intl-msg:slider.oneMonthBooking.readMoreText3'
                            />,
                        ],
                    },
                }}
                currentVersion={CUSTOMER_CENTER_RELEASE_NOTES_VERSION}
                RELEASE_NOTES_ITEM={CUSTOMER_CENTER_RELEASE_NOTES_STORAGE_KEY}
            />
        </>
    );
};
